import { AuthenticationContext } from 'react-adal';
import { AUTH_TENANT, AUTH_CLIENT } from '../config/config';

var origin = window && window.location && window.location.origin;

export const adalConfig = {
    tenant: AUTH_TENANT,
    clientId: AUTH_CLIENT,
    endpoints: {
        // api: origin + '/auth',
        api: AUTH_CLIENT,
    },
    redirectUri: origin + '/auth',
    cacheLocation: 'localStorage',
};
 
var validConfig = (AUTH_TENANT != null && AUTH_CLIENT != null);

export const authContext = validConfig ? new AuthenticationContext(adalConfig) : null;

export const getTokenAsync = validConfig ? (callback) => authContext.acquireToken(adalConfig.clientId, callback) : null;
export const getCachedToken = validConfig ? () => authContext.getCachedToken(adalConfig.clientId) : null;



// WEBPACK FOOTER //
// ./src/config/adalConfig.js